import { store } from '@sonifi/wb-core/store/store';
import { initForm } from '../services/remote-ordering.service';

export async function loaderOrderRemotes() {
  store.dispatch(initForm());
  return {};
}
